import Vue from 'vue'

let lastTimestamp = 0
let sequence = 0

export function getUUID() {
  const timestamp = Date.now()
  const sequenceMax = 9999

  if (timestamp === lastTimestamp) {
    sequence = (sequence + 1) % sequenceMax
    if (sequence === 0) {
      // 确保时间戳向前移动
      while (Date.now() <= lastTimestamp) {}
    }
  } else {
    sequence = 0
  }

  lastTimestamp = timestamp

  // 将时间戳和序列号格式化为字符串，并确保序列号是4位数字
  const timestampStr = timestamp.toString()
  const sequenceStr = sequence.toString().padStart(4, '0')

  // 截取时间戳的后14位，并添加序列号，确保总长度为19位
  return timestampStr.substring(timestampStr.length - 14) + sequenceStr
}

export const cloneVNode = (vnode) => {
  const createElement = Vue.prototype.$bus.$createElement
  const clonedChildren = vnode.children && vnode.children.map((vnode) => cloneVNode(vnode))
  const cloned = createElement(vnode.tag, vnode.data, clonedChildren)
  cloned.text = vnode.text
  cloned.isComment = vnode.isComment
  cloned.componentOptions = vnode.componentOptions
  cloned.elm = vnode.elm
  cloned.context = vnode.context
  cloned.ns = vnode.ns
  cloned.isStatic = vnode.isStatic
  cloned.key = vnode.key
  return cloned
}

export const deepClone = (target) => {
  let result
  if (typeof target === 'object') {
    if (Array.isArray(target)) {
      result = []
      for (let i in target) {
        result.push(deepClone(target[i]))
      }
    } else if (target === null) {
      result = null
    } else if (target.constructor === RegExp) {
      result = target
    } else if (target.constructor && target.constructor.name === 'VNode') {
      result = cloneVNode(target)
    } else {
      result = {}
      for (let i in target) {
        result[i] = deepClone(target[i])
      }
    }
  } else {
    result = target
  }
  return result
}

export const getIcon = (fieldType, fieldTypeMap) => {
  const fieldTypeIconMap = {
    文本: 'icon-ziduan',
    数值: 'icon-shuzhi',
    日期: 'icon-riqi',
    日期时间: 'icon-riqishijian',
  }
  return fieldTypeIconMap[fieldTypeMap[fieldType?.toUpperCase()]]
}

export const isEmpty = (value) => {
  return value === '' || value === null || value === undefined
}

// html过滤出文本内容
export const htmlFilterText = (htmlStr) => {
  return htmlStr?.replace(/<.*?>/g, '').replace(/\n/g, '').replace(/\r/g, '')
}


export const wordsJoin = (name1, name2) => {
  let str = name1
  if (name2) {
    const fieldName = str ? `${str}(${name2})` : '--'
    str = `<span class="text-overflow" title="${fieldName}">${fieldName}</span>`
  }
  return name1 ? str : name2 || '--'
}